module.exports = __webpack_public_path__ + "static/media/Whatsapp.91d01938.svg";